'use client'

import { useSidebarStore } from '@/app/hooks/sidebarStore'

export default function SidebarMarginWrapper({
  children,
}: {
  children: React.ReactNode
}) {
  const isCollapsed = useSidebarStore((state) => state.isCollapsed)
  const marginClass = isCollapsed ? 'md:ml-16' : 'md:ml-64'

  return (
    <div className={`${marginClass} transition-all duration-300`}>
      {children}
    </div>
  )
}
